import { clients } from "../../../lib/axios";
import { AxiosError } from "axios";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { OperationalContactDto } from "../types";
import { OperationalContactKeys } from "./operationalContact.keys";

const addOperationalContact = async (data: OperationalContactDto, idProject: string) => {
  const axios = await clients();

  return axios
    .post("/api/operationalcontacts/"+ idProject, data)
    .then((response) => response.data as OperationalContactDto);
};

export function useAddOperationalContact(id: string,
  options?: UseMutationOptions<OperationalContactDto, AxiosError, OperationalContactDto>
) {
  const queryClient = useQueryClient();

  return useMutation(
    (newOperationalContact: OperationalContactDto) => addOperationalContact(newOperationalContact, id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(OperationalContactKeys.lists());
      },
      ...options,
    }
  );
}
